var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"id":"app"}},[(_vm.layout === 'secure')?_c('SecureLayout',[_c('router-view',{key:_vm.$route.path})],1):_c('InSecureLayout',{key:_vm.reload},[_c('router-view',{key:_vm.$route.path})],1),_c('GlobalError')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }